<template>
    <Modal :visible="visible" @update:visible="v => $emit('update:visible', v)">
        <template v-slot:title>
            {{ __('actions.select_thing', {thing: __('general.stores')}) }}
        </template>

        <FormGroupNew :label="__('general.stores')"
                      required
        >
            <SearchStore v-model="store" />
        </FormGroupNew>

        <button class="btn btn-primary"
                @click="addStores"
                :disabled="!store"
        >
            <i class="fas fa-plus-square"/>
            {{ __('actions.add_thing', {thing: __('general.stores')}) }}
        </button>
    </Modal>
</template>

<script>
import Modal from "@components/Modal.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import SearchStore from "@components/Store/SearchStore.vue";

export default {
    components: {SearchStore, FormGroupNew, Modal},

    emits: ['update:visible'],

    props: {
        offer: Object,
        visible: Boolean
    },

    data() {
        return {
            store: null
        }
    },

    methods: {
        addStores() {
            this.$inertia.post(this.$route('offers.stores.update', this.offer.id), {
                action: 'add',
                store_uuids: [this.store.id]
            }, {
                onSuccess: () => {
                    this.store = null;
                    this.$emit('update:visible', false)
                }
            })
        }
    }
}
</script>
